import { put, select } from 'redux-saga/effects'
import { takeLatest } from '@redux-saga/core/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { setAddMedicalConsultToTimeline } from '../store/quickActions.actions'
import { resetState } from '../../procedures/medicalConsult/store/medicalConsult.actions'
import { addMedicalConsultItem } from '../../timeline/store/timeline.actions'
import { MedicalConsultConstants } from '../../procedures/medicalConsult/store/medicalConsult.constants'

export function* saveMedicalConsultQuickActionTimeLineRow() {
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { addMedicalConsultToTimeline } = quickActionsObject
  if (addMedicalConsultToTimeline) {
    yield put(addMedicalConsultItem())
    yield put(setAddMedicalConsultToTimeline(false))
    yield put(resetState())
  }
}

export function* saveMedicalConsultQuickActionTimeLineRowSaga() {
  yield takeLatest([MedicalConsultConstants.SET_ADD_TO_TIMELINE], saveMedicalConsultQuickActionTimeLineRow)
}
